module.exports = __webpack_public_path__ + "assets/img/00013.259e31fd.png";